import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_BASE_KEY } from "@/constants/query-key";

export type TeamMinShift = Partial<Record<"D" | "E" | "N" | "M", number>>;

export type TeamHandoffPolicy = Record<string, unknown>;

export type TeamSchema = {
  team_id: number;
  team_name: string;
  team_members: string[];
  min_shift: TeamMinShift | null;
  handoff_policy: TeamHandoffPolicy | null;
};

export type TeamsSchema = {
  team_id: number;
  team_name: string;
  team_members: string[];
  min_shift?: TeamMinShift | null;
  handoff_policy?: TeamHandoffPolicy | null;
}[];

export function useTeamsQuery(groupId: string | null) {
  return useQuery<TeamsSchema>({
    queryKey: [QUERY_BASE_KEY.TEAMS, groupId],
    queryFn: () =>
      httpClient.get<TeamsSchema>(
        groupId ? `/teams?group_id=${groupId}` : "/teams"
      ),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
